import { render, staticRenderFns } from "./Recetas.vue?vue&type=template&id=7eb23172&scoped=true"
import script from "./Recetas.vue?vue&type=script&lang=js"
export * from "./Recetas.vue?vue&type=script&lang=js"
import style0 from "./Recetas.vue?vue&type=style&index=0&id=7eb23172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb23172",
  null
  
)

export default component.exports